import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ArrowRightIcon } from 'lucide-react';
import { SparkleIcon } from './icons/NailIcons';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/96d8aedd-8fbe-4956-a7d0-348df805a9a7.jpg';
const HERO_ALT = 'Manos con manicura soft gel en tono rosa nude, con detalle de moño y perlas';
function HeroImage() {
  return <div className="overflow-hidden rounded-[2.5rem] bg-white p-3 shadow-lift" data-id="element-186" data-mp="12a0j75mcfqrz">
      <img src={HERO_IMAGE} alt={HERO_ALT} className="aspect-[4/5] w-full rounded-[2rem] object-cover" data-id="element-187" data-mp="xano5xlbjdeb" />
    </div>;
}
export function Hero() {
  return <section id="inicio" className="relative w-full overflow-hidden bg-gradient-to-br from-blush-100 via-blush-200 to-rosegold/40" data-id="element-188" data-mp="sd47ys528qjq">
      <div className="mx-auto grid w-full max-w-7xl items-center gap-12 px-5 pb-16 pt-28 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:pb-24 lg:pt-36" data-id="element-189" data-mp="3d2ldtocrhr6i">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-190" data-mp="3j8iwex8gcctn">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/70 bg-white/70 px-4 py-2 text-xs font-semibold tracking-wide text-fucsia-ink backdrop-blur-sm" data-id="element-191" data-mp="3o5j1b4tkf9j6">
            <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-192" data-mp="3e7l8e40rgok8" />
            Prado, Montevideo
          </span>

          <h1 className="mt-6 font-serif text-[2.6rem] font-semibold leading-[1.05] tracking-tight text-ink sm:text-6xl lg:text-[4.25rem]" data-id="element-193" data-mp="30g6jxho33v5s">
            Uñas, risas y buena onda
            <span className="relative ml-3 inline-flex items-start" data-id="element-194" data-mp="2qloeo830rrjv">
              <span className="italic text-fucsia-deep" data-id="element-195" data-mp="2vjzo4hpek01k">siempre</span>
              <SparkleIcon className="ml-1 mt-1 h-6 w-6 text-fucsia sm:h-8 sm:w-8" data-id="element-196" data-mp="2hjf8tvip4mct" />
            </span>
          </h1>

          {/* En mobile la foto acompaña al titular; en desktop vive en la columna derecha */}
          <div className="mt-8 lg:hidden" data-id="element-197" data-mp="s2b921mmap6q">
            <HeroImage data-id="element-198" data-mp="s3cmudv0pps5" />
          </div>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-199" data-mp="nbl3anaa4kbi">
            Tu estudio de uñas en Prado, Montevideo — donde la calidad es garantía. Diseños
            personalizados, materiales premium y ese rato para vos que tanto merecés.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-200" data-mp="db2fjhflgjob">
            <a href="#reservar" className="group inline-flex items-center justify-center gap-2 rounded-full bg-fucsia-deep px-8 py-4 text-base font-semibold text-white shadow-lift transition-[transform,background-color] duration-150 ease-smooth hover:-translate-y-0.5 hover:bg-fucsia-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fucsia-ink" data-id="element-201" data-mp="1b04bz3x8qz44">
              Agendar turno ahora
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-202" data-mp="3hqam6y4cdrp9" />
            </a>
            <a href="#trabajos" className="inline-flex items-center justify-center rounded-full border border-fucsia-deep/30 bg-white/80 px-8 py-4 text-base font-semibold text-fucsia-ink transition-[transform,background-color] duration-150 ease-smooth hover:-translate-y-0.5 hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fucsia-deep" data-id="element-203" data-mp="21bpo3l0bc13u">
              Ver galería de trabajos
            </a>
          </div>

          <div className="mt-12 max-w-xs border-t border-white/70 pt-7" data-id="element-204" data-mp="2p10imkr2kz9j">
            <p className="font-script text-4xl leading-none text-fucsia-ink sm:text-5xl" data-id="element-205" data-mp="2tyiscdcwviil">
              Camila Santana
            </p>
            <p className="mt-3 text-xs font-medium uppercase tracking-[0.18em] text-ink-soft" data-id="element-206" data-mp="uokcdjy9xl4o">
              Nail artist &amp; fundadora
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative hidden w-full lg:block" data-id="element-207" data-mp="49jbi0f0ifk0">
          <HeroImage data-id="element-208" data-mp="99xidf4vnjgg" />
          <div className="absolute -bottom-6 -left-8 rounded-3xl border border-blush-200 bg-white px-5 py-4 shadow-soft" data-id="element-209" data-mp="9bs8r8yx43rx">
            <p className="font-serif text-xl font-semibold text-ink" data-id="element-210" data-mp="3hqjzsebhkq7q">Especialista en uñas premium</p>
            <p className="mt-0.5 text-sm text-ink-soft" data-id="element-211" data-mp="3ct0kdb31y7e7">Soft gel · Kapping · Nail art</p>
          </div>
        </motion.div>
      </div>
    </section>;
}